<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>分佣配置管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleAdd('addForm')">添加云仓配置</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleAdd('shoppingForm')">添加商品类型配置
        </el-button>
        <el-button size="small" type="danger" plain icon="el-icon-delete" @click="handleDelType()">删除商品类型配置</el-button>
      </el-form-item>
    </el-form>
    <div class="mb20">云仓配置：</div>
    <el-table size="small" class="mb20"
              :data="listData"
              highlight-current-row
              v-loading="loading"
              border
              :header-cell-style="{color:'#666',fontSize:'14px'}"
              element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column prop="yunCangId" label="云仓类型" align="center">
        <template slot-scope="scope">
          {{ scope.row.yunCangId == -1 ? '默认' :getThirdFlag(scope.row.yunCangId)}}
        </template>
      </el-table-column>
      <el-table-column prop="consolidatedTax" label="综合税" align="center">
      </el-table-column>
      <el-table-column prop="advanceConsolidatedTax" label="手续费" align="center">
      </el-table-column>
      <el-table-column align="center" width="150" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="warning" plain @click="handleEdit('', scope.row)">修改</el-button>
          <el-button size="mini" type="danger" v-if="scope.row.yunCangId!==-1" plain @click="handleDel(scope.row)">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="mb20">商品利型配置：</div>
    <el-table size="small"
              :data="typelistData"
              highlight-current-row
              :row-class-name="tableRowClassName"
              v-loading="typeloading"
              border
              :header-cell-style="{color:'#666',fontSize:'14px'}"
              :span-method="objectSpanMethod"
              element-loading-text="拼命加载中"
              style="width: 100%;">
      <el-table-column prop="commodityTypeId" label="商品类型" align="center">
        <template slot-scope="scope">
          {{ getDictKeyById(typeOptions, scope.row.commodityTypeId, 'name') }}
        </template>
      </el-table-column>
      <el-table-column prop="profitType" label="商品利润类型" align="center">
        <template slot-scope="scope">
          {{ getDictKeyByKey(profitTypeOptions, scope.row.profitType, 'value') }}
        </template>
      </el-table-column>
      <el-table-column prop="leaderLevel" label="团长等级" align="center">
        <template slot-scope="scope">
          <el-tag>{{ scope.row.leaderLevel }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="incomePercentage" label="分佣比例" align="center">
      </el-table-column>
      <el-table-column align="center" width="150" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="warning" plain @click="handleEdit('type', scope.row)">修改</el-button>
          <!-- <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
    <!-- 添加云仓界面 -->
    <el-dialog :title="title" :visible.sync="addFormVisible" width="30%" @click="closeDialog('editForm')">
      <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">
        <el-form-item label="选择云仓" prop="yunCangId">
          <el-select
            :disabled="disable"
            size="small"
            clearable
            filterable
            class="full_select"
            v-model="editForm.yunCangId"
            placeholder="请选择云仓"
          >
            <el-option
              v-for="item in productSource"
              :key="item.value + '-smlxkey'"
              :label="item.key"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="综合税" prop="consolidatedTax">
          <el-input-number v-model="editForm.consolidatedTax" size="small" class="full_select"
                           :max="1"></el-input-number>
        </el-form-item>
        <el-form-item label="手续费" prop="advanceConsolidatedTax">
          <el-input-number v-model="editForm.advanceConsolidatedTax" size="small" class="full_select"
                           :max="1"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('editForm')">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存
        </el-button>
      </div>
    </el-dialog>
    <!-- 修改商品利润类型界面 -->
    <el-dialog :title="title" :visible.sync="shoppingFormVisible" width="30%" @click="closeDialog('editForm')">
      <el-form label-width="120px" :model="shoppingEditForm" ref="shoppingEditForm" :rules="shoppingRules">
        <el-form-item label="商品类型" prop="commodityTypeId">
          <el-select
            size="small"
            :disabled="disable"
            clearable
            filterable
            class="full_select"
            v-model="shoppingEditForm.commodityTypeId"
            placeholder="请选择商品类型"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.id + '-splxkey'"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品利润类型" prop="commodityTypeId">
          <el-select
            size="small"
            :disabled="disable"
            clearable
            filterable
            class="full_select"
            v-model="shoppingEditForm.profitType"
            placeholder="请选择商品利润类型"
          >
            <el-option
              v-for="item in profitTypeOptions"
              :key="item.id + '-splrlxkey'"
              :label="item.value"
              :value="Number(item.key)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="团长等级" prop="leaderLevel">
          <el-select
            :disabled="disable"
            size="small"
            clearable
            filterable
            class="full_select"
            v-model="shoppingEditForm.leaderLevel"
            placeholder="请选择团长等级"
          >
            <el-option
              v-for="item in 3"
              :key="item + '-smlxkey'"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="佣金比例" prop="incomePercentage">
          <el-input-number v-model="shoppingEditForm.incomePercentage" size="small" class="full_select"
                           :max="1"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('editForm')">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('shoppingEditForm')">
          保存
        </el-button>
      </div>
    </el-dialog>
    <!-- 添加商品分类界面 -->
    <el-dialog :title="title" :visible.sync="addshoppingFormVisible" width="30%" @click="closeDialog('editForm')">
      <el-form label-width="120px" :model="shoppingAddForm" ref="shoppingAddForm" :rules="shoppingaddRules">
        <el-form-item label="商品类型" prop="commodityTypeId">
          <el-select
            size="small"
            :disabled="disable"
            clearable
            filterable
            class="full_select"
            v-model="shoppingAddForm.commodityTypeId"
            placeholder="请选择商品类型"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.id + '-splxkey'"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="高利润佣金配置">
        </el-form-item>
        <el-form-item label="一级团长佣金" prop="highIncomePercentage1">
          <el-input-number v-model="shoppingAddForm.highIncomePercentage1" size="small" class="full_select"
                           :max="1"></el-input-number>
        </el-form-item>
        <el-form-item label="二级团长佣金" prop="highIncomePercentage2">
          <el-input-number v-model="shoppingAddForm.highIncomePercentage2" size="small" class="full_select"
                           :max="1"></el-input-number>
        </el-form-item>
        <el-form-item label="三级团长佣金" prop="highIncomePercentage3">
          <el-input-number v-model="shoppingAddForm.highIncomePercentage3" size="small" class="full_select"
                           :max="1"></el-input-number>
        </el-form-item>
        <el-form-item label="低利润佣金配置">
        </el-form-item>
        <el-form-item label="一级团长佣金" prop="lowIncomePercentage1">
          <el-input-number v-model="shoppingAddForm.lowIncomePercentage1" size="small" class="full_select"
                           :max="1"></el-input-number>
        </el-form-item>
        <el-form-item label="二级团长佣金" prop="lowIncomePercentage2">
          <el-input-number v-model="shoppingAddForm.lowIncomePercentage2" size="small" class="full_select"
                           :max="1"></el-input-number>
        </el-form-item>
        <el-form-item label="三级团长佣金" prop="lowIncomePercentage3">
          <el-input-number v-model="shoppingAddForm.lowIncomePercentage3" size="small" class="full_select"
                           :max="1"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('shoppingAddForm')">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title"
                   @click="submitTypeForm('shoppingAddForm')">保存
        </el-button>
      </div>
    </el-dialog>
    <!-- 删除商品分类弹窗 -->
    <el-dialog title="选择删除" :visible.sync="visibleDelDialog" width="30%" @click="visibleDelDialog=false">
      <el-checkbox-group v-model="delcheckList">
        <el-checkbox v-for="item in delcheckOption" :key="item.id" :label="item" :disabled="item.id == 0">{{ item.name }}</el-checkbox>
      </el-checkbox-group>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="visibleDelDialog=false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitDel('editForm')">确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {addDictType, delDictType, editDictType, dictTypeList, configureList, addConfigure} from '@/api/system'
import {getClassiFicationTypeList,} from '@/api/basisMG'
import Pagination from '@/components/Pagination'
import {dataMethod} from '@/utils/elespancloum';
import {getDictByTypeId} from "@/api/system";

export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      disable: false,
      loading: false, //是显示加载
      typeloading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      addFormVisible: false,
      shoppingFormVisible: false,
      addshoppingFormVisible: false,
      visibleDelDialog: false,
      title: '添加',
      delcheckList: [],
      delcheckOption: [],
      activeText: ['禁用', '启用'],
      editForm: {
        commodityTypeId: ''
      },
      shoppingEditForm: {}, //商品类型
      shoppingAddForm: {},
      typeOptions: [{id: 0, name: '默认'}], //商品分类字典
      profitTypeOptions: [], //利润类型字典
      ycList: ['极光一件代发', '麦帮', '私有', '洋葱'],
      productSource:[],
      // rules表单验证
      rules: {
        yunCangId: [
          {required: true, message: "请选择云仓类型", trigger: "change"},
        ],
        consolidatedTax: [
          {required: true, message: "请输入综合税", trigger: "blur"},
          {
            pattern: /^1$|^0(\.\d{1,3})?$/,
            required: true,
            message: '请输入小于1且不超过三位的小数',
            trigger: 'blur',
            transform: (value) =>
              this.$options.filters.formValidateFun(value, "number"),
          },
        ],
        advanceConsolidatedTax: [
          {required: true, message: "请输入手续费", trigger: "blur"},
          {
            pattern: /^1$|^0(\.\d{1,3})?$/,
            required: true,
            message: '请输入小于1且不超过俩位的小数',
            trigger: 'blur',
            transform: (value) =>
              this.$options.filters.formValidateFun(value, "number"),
          },
        ],
      },
      shoppingRules: {
        commodityTypeId: [
          {required: true, message: "请选择商品类型", trigger: "change"},
        ],
        leaderLevel: [
          {required: true, message: "请选择团长等级", trigger: "change"},
        ],
        incomePercentage: [
          {required: true, message: "请输入佣金比例", trigger: "blur"},
          {
            pattern: /^(0(\.\d{1,2})?|1(\.0{1,2})?)$/,
            required: true,
            message: '请输入小于1且不超过俩位的小数',
            trigger: 'blur',
            transform: (value) =>
              this.$options.filters.formValidateFun(value, "number"),
          },
        ],
      },
      shoppingaddRules: {
        commodityTypeId: [
          {required: true, message: "请选择商品类型", trigger: "change"},
        ],
        highIncomePercentage1: [
          {required: true, message: "请输入一级团长佣金", trigger: "blur"},
          {
            pattern: /^(0(\.\d{1,2})?|1(\.0{1,2})?)$/,
            required: true,
            message: '请输入小于1且不超过俩位的小数',
            trigger: 'blur',
            transform: (value) =>
              this.$options.filters.formValidateFun(value, "number"),
          },
        ],
        highIncomePercentage2: [
          {required: true, message: "请输入二级团长佣金", trigger: "blur"},
          {
            pattern: /^(0(\.\d{1,2})?|1(\.0{1,2})?)$/,
            required: true,
            message: '请输入小于1且不超过俩位的小数',
            trigger: 'blur',
            transform: (value) =>
              this.$options.filters.formValidateFun(value, "number"),
          },
        ],
        highIncomePercentage3: [
          {required: true, message: "请输入三级团长佣金", trigger: "blur"},
          {
            pattern: /^(0(\.\d{1,2})?|1(\.0{1,2})?)$/,
            required: true,
            message: '请输入小于1且不超过俩位的小数',
            trigger: 'blur',
            transform: (value) =>
              this.$options.filters.formValidateFun(value, "number"),
          },
        ],
        lowIncomePercentage1: [
          {required: true, message: "请输入一级团长佣金", trigger: "blur"},
          {
            pattern: /^(0(\.\d{1,2})?|1(\.0{1,2})?)$/,
            required: true,
            message: '请输入小于1且不超过俩位的小数',
            trigger: 'blur',
            transform: (value) =>
              this.$options.filters.formValidateFun(value, "number"),
          },
        ],
        lowIncomePercentage2: [
          {required: true, message: "请输入二级团长佣金", trigger: "blur"},
          {
            pattern: /^(0(\.\d{1,2})?|1(\.0{1,2})?)$/,
            required: true,
            message: '请输入小于1且不超过俩位的小数',
            trigger: 'blur',
            transform: (value) =>
              this.$options.filters.formValidateFun(value, "number"),
          },
        ],
        lowIncomePercentage3: [
          {required: true, message: "请输入三级团长佣金", trigger: "blur"},
          {
            pattern: /^(0(\.\d{1,2})?|1(\.0{1,2})?)$/,
            required: true,
            message: '请输入小于1且不超过俩位的小数',
            trigger: 'blur',
            transform: (value) =>
              this.$options.filters.formValidateFun(value, "number"),
          },
        ],
      },
      formInline: {
        page: 1,
        limit: 10,
        configureKey: 'AHL_LEADER_INCOME_PERCENTAGE_CONFIG'
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //云仓
      typelistData: [],//团长数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      spanObj: {},
      //data里面需要合并的项以及对应的spanArr和pos
      mergerItems: [
        {   columnIndex:0,
          spanArr: [],
          pos: 0,
          prop: 'commodityTypeId',
          parent:[]
        },
        {   columnIndex:1,
          spanArr: [],
          pos: 0,
          prop: 'profitType',
          parent:['commodityTypeId']
        }],

    }
  },
  // 注册组件
  components: {
    Pagination
  },
  created() {
    this.getdata(this.formInline)
    this.getTypeList()
    this.getDict()
  },
  //  configureKey AHL_LEADER_INCOME_PERCENTAGE_CONFIG AHL_LEADER_YUNCANG_KIND_CONFIG configureList addConfigure
  methods: {
    getTypeList() {
      getClassiFicationTypeList().then(res => {
        this.typeOptions.push(...res.body)
      })
      getDictByTypeId(19).then(res => {
        this.profitTypeOptions = res.body
      })
    },
    //获取字典数据
    getDict() {
      this.getDictById(32)
    },
    async getDictById(id) {
      const {body} =  await getDictByTypeId(id)
      this.productSource = body
    },
    getSpanArr(data, array) {//循环数据处理
      for (let n = 0; n < array.length; n++) {
        array[n].spanArr = []//数据清空(重新调此方法的时候需要清空上一次的数据)
        for (let i = 0; i < data.length; i++) {
          if (i === 0) {
            array[n].spanArr.push(1);
            array[n].pos = 0;
          } else {

            // 判断当前元素与上一个元素是否相同
            let flag = true;
            for (let j = 0; j < array[n].parent.length; j++) {

              if (data[i][array[n].parent[j]] !== data[i - 1][array[n].parent[j]]) {
                flag = false;
                break;
              }
            }
            if (flag && data[i][array[n].prop] === data[i - 1][array[n].prop]) {
              array[n].spanArr[array[n].pos] += 1;
              array[n].spanArr.push(0);
            } else {
              array[n].spanArr.push(1);
              array[n].pos = i;
            }
          }
        }
      }
    },
    objectSpanMethod({row, column, rowIndex, columnIndex}) {

      if (columnIndex === 0 || columnIndex === 1) {
        let item = this.mergerItems.find(item => item.columnIndex === columnIndex)
        const _row = item.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        }
      }

    },
    getdata(parameter) {
      this.typeloading = true
      this.loading = true
      configureList(parameter).then(res => {
        this.typeloading = false
        if (res.rsp_code != 200) {
          this.$message({
            type: 'info',
            message: res.rsp_msg
          })
        } else {
          this.typelistData = res.body
          this.spanObj = dataMethod(this.typelistData, ['commodityTypeId']);
          this.getSpanArr(this.typelistData, this.mergerItems)
          // 分页赋值
          this.pageparm.currentPage = this.formInline.page
          this.pageparm.pageSize = this.formInline.limit
          this.pageparm.total = res.body.total
        }
      })
        .catch(err => {
          this.typeloading = false
          this.$message.error('加载失败，请稍后再试！')
        })
      // 云仓
      let ycpar = {
        page: 1,
        limit: 10,
        configureKey: 'AHL_LEADER_YUNCANG_KIND_CONFIG'
      }
      configureList(ycpar).then(res => {
        this.loading = false
        if (res.rsp_code != 200) {
          this.$message({
            type: 'info',
            message: res.rsp_msg
          })
        } else {
          this.listData = res.body
        }
      })
        .catch(err => {
          this.loading = false
          this.$message.error('云仓数据加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.formInline.page = 1
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function (name, row) {
      this.disable = false
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.disable = true
        if (name == 'type') {
          this.shoppingFormVisible = true
          this.shoppingEditForm = row
        } else {
          this.addFormVisible = true
          this.editForm = row
        }
      }
    },
    handleAdd(formName) {
      this.disable = false
      if (formName == 'shoppingForm') {
        this.addshoppingFormVisible = true
        this.shoppingEditForm = {
          configureKey: 'AHL_LEADER_INCOME_PERCENTAGE_CONFIG',
        }
      } else {
        this.addFormVisible = true
        this.editForm = {
          configureKey: 'AHL_LEADER_YUNCANG_KIND_CONFIG',
        }
      }
      this.title = '添加'
    },
    // 修改商品分类  添加、修改云仓
    submitForm(editName) {
      // shoppingEditForm typelistData listData
      this.$refs[editName].validate(valid => {
        if (valid) {
          let key = editName == 'shoppingEditForm' ? 'AHL_LEADER_INCOME_PERCENTAGE_CONFIG' : 'AHL_LEADER_YUNCANG_KIND_CONFIG'
          let list = editName == 'shoppingEditForm' ? this.typelistData : this.listData
          let par = {}
          if (this.title == '修改') {
            par = {
              configureKey: key,
              valueList: list
            }
          } else {
            // 新增时候拦截相同的云仓 yunCangId commodityTypeId
            let isHave;
            isHave = list.filter(item => item.yunCangId == this.editForm.yunCangId)
            console.log(isHave, 'isHave');
            if (isHave.length > 0) {
              this.$message({
                type: 'warning',
                message: `当前云仓已有规则，请勿继续添加！`
              })
              return false
            } else {
              let listobj = {
                advanceConsolidatedTax: this.editForm.advanceConsolidatedTax,
                consolidatedTax: this.editForm.consolidatedTax,
                yunCangId: this.editForm.yunCangId,
                defaultValue: this.editForm.yunCangId == -1 ? 1 : 0
              }
              list.push(listobj)
              par = {
                configureKey: key,
                valueList: list
              }
            }
          }
          // console.log(par);
          addConfigure(par).then(res => {
            this.addFormVisible = false
            this.shoppingFormVisible = false
            this.loading = false
            this.typeloading = false
            if (res.rsp_code == 200) {
              this.getdata(this.formInline)
              this.$message({
                type: 'success',
                message: `${this.title}成功！`
              })
            } else {
              this.$message({
                type: 'info',
                message: res.rsp_msg
              })
            }
          }).catch(err => {
            this.addFormVisible = false
            this.shoppingFormVisible = false
            this.loading = false
            this.typeloading = false
            this.$message.error(`${this.title}失败，请稍后再试！`)
          })
        } else {
          return false
        }
      })
    },
    // 添加商品分类
    submitTypeForm(editName) {

      let isHave = []
      // console.log(list,'list',this.shoppingAddForm,'this.shoppingAddForm','this.typelistData',this.typelistData);
      isHave = this.typelistData.filter(item => item.commodityTypeId == this.shoppingAddForm.commodityTypeId)
      // console.log(isHave,'isHave');
      if (isHave.length > 0) {
        this.$message({
          type: 'warning',
          message: `当前商品类型已有规则，请勿继续添加！`
        })
        return false
      }


      // console.log(params);
      this.$refs[editName].validate(valid => {
        if (valid) {
          let list = []
          for (let i = 0; i < 6; i++) {
            let item = {}
            item.commodityTypeId = this.shoppingAddForm.commodityTypeId,
              item.defaultValue = this.shoppingAddForm.commodityTypeId != 0 ? 0 : 1;
            if (i < 3) {
              //高利润
              item.profitType = 2;
              item.leaderLevel = i + 1;
              item.incomePercentage = this.shoppingAddForm[`highIncomePercentage${i + 1}`]
            } else if (6 > i && i >= 3) {
              //低利润
              item.profitType = 1;
              item.leaderLevel = i - 2;
              item.incomePercentage = this.shoppingAddForm[`highIncomePercentage${i - 2}`]
            }
            list.push(item)
          }
          console.log(list)
          // console.log(list,'list',this.shoppingAddForm,'this.shoppingAddForm','this.typelistData',this.typelistData);
          list = list.concat(this.typelistData)
          let params = {
            configureKey: 'AHL_LEADER_INCOME_PERCENTAGE_CONFIG',
            valueList: list
          }
          addConfigure(params).then(res => {
            this.addshoppingFormVisible = false
            this.typeloading = false
            if (res.rsp_code == 200) {
              this.getdata(this.formInline)
              this.$message({
                type: 'success',
                message: `${this.title}成功！`
              })
            } else {
              this.$message({
                type: 'info',
                message: res.rsp_msg
              })
            }
          }).catch(err => {
            this.addshoppingFormVisible = false
            this.typeloading = false
            this.$message.error(`${this.title}失败，请稍后再试！`)
          })
        } else {
          return false
        }
      })
    },
    // 删除云仓
    handleDel(row) {
      if (row.yunCangId != -1) {
        let newlist = this.listData.filter(item => row.yunCangId !== item.yunCangId)
        let par = {
          configureKey: 'AHL_LEADER_YUNCANG_KIND_CONFIG',
          valueList: newlist
        }
        let name = this.getThirdFlag(row.yunCangId)
        this.$confirm('确定要删除' + name + '云仓吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          addConfigure(par).then(res => {
            if (res.rsp_code == 200) {
              this.getdata(this.formInline)
              this.$message.success('删除成功！')
            }
          })
        })
      } else {
        this.$message.warning('默认数据不可删除！')
      }
    },
    // 删除分类配置
    handleDelType() {
      this.delcheckOption = []
      this.visibleDelDialog = true
      // delcheckList  delcheckOption typelistData
      // 查找目前数据里包含分类 生成数组带 commodityTypeId ，通过选中 commodityTypeId 筛选掉已有数据相同的，提交（排除默认0）
      // console.log(this.typelistData,this.typeOptions);
      let commodityTypeId = []
      this.typelistData.forEach(item => {
        commodityTypeId.push(item.commodityTypeId)
      })
      let commodityTypeIdArray = commodityTypeId.filter((item, index, array) => {
        return array.indexOf(item) === index
      })
      // console.log(commodityTypeIdArray); //取到已有列表包含的id
      for (let index = 0; index < this.typeOptions.length; index++) {
        const element = this.typeOptions[index];
        // console.log(element)
        for (let j = 0; j < commodityTypeIdArray.length; j++) {
          const jitem = commodityTypeIdArray[j];
          // console.log(jitem)
          if (jitem == element.id) {
            console.log(element)
            this.delcheckOption.push(element)
          }
        }
      }
      // console.log('this.delcheckOption',this.delcheckOption);

    },
    // 提交 删除分类配置
    submitDel() {
      // console.log(this.delcheckList,'this.delcheckList');
      // 筛选 -- 删除
      let newlist = []
      for (let i = 0; i < this.typelistData.length; i++) {
        const element = this.typelistData[i];
        for (let j = 0; j < this.delcheckList.length; j++) {
          const jitem = this.delcheckList[j];
          if (jitem.id !== element.commodityTypeId) {
            newlist.push(element)
          }
        }
      }
      //  console.log(newlist,'newlist');
      let par = {
        configureKey: 'AHL_LEADER_INCOME_PERCENTAGE_CONFIG',
        valueList: newlist
      }
      let name = this.delcheckList[0].name
      this.$confirm('确定要删除' + name + '分类配置吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        addConfigure(par).then(res => {
          this.visibleDelDialog = false
          if (res.rsp_code == 200) {
            this.getdata(this.formInline)
            this.$message.success('删除成功！')
          }
        })
      })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.addshoppingFormVisible = false
      this.shoppingFormVisible = false
      this.addFormVisible = false
      this.getdata(this.formInline)
    },
    // 根据字典id获取字典key
    getDictKeyById(options, id, keyString) {
      let key = "";

      options.forEach((item) => {
        if (item['id'] * 1 == id * 1) {
          key = item[keyString];
        }
      });
      return key;
    },
    getDictKeyByKey(options, id, keyString) {
      let key = "";

      options.forEach((item) => {
        if (item.key * 1 == id * 1) {
          key = item[keyString];
        }
      });
      return key;
    },
    getThirdFlag(flag) {
      let text =null;

      if (flag != null) {
        let list = this.productSource.filter( item => item.id === flag)
        text = list[0].key
      }
      else {
        text = "私有";
      }
      // console.log(text)
      return text;
    },
    tableRowClassName({row, rowIndex}) {
      // console.log((rowIndex+1) % 3);
      // if (((rowIndex+1) % 3 === 1 || (rowIndex+1) % 3=== 2 || (rowIndex+1) % 3 === 0) ) {
      //   return 'warning-row';
      // } else if (rowIndex === 3) {
      //   return 'success-row';
      // }
      // return '';
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}

.prople_info {
  height: 100%;
  padding: 30px;
}
</style>




// WEBPACK FOOTER //
// src/views/system/groupConfig.vue